  
import { useEffect } from 'react'
import { socketListenerSubscriber } from './sockets'
import { useDispatch } from 'react-redux'

/**
 * @typedef {Object} SocketProviderProps
 * @property {React.ReactNode} children
 */

/**
 * @type {React.FunctionComponent<SocketProviderProps>}
 */
const WebSockets = ({ children }) => {
  const dispatch = useDispatch()
  

  useEffect(() => {
    socketListenerSubscriber({ dispatch })
  }, [dispatch])

  return children
}

export default WebSockets